import { DxDataGridModule, DxButtonModule } from 'devextreme-angular';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LevelingSideGridComponent } from './leveling-side-grid.component';



@NgModule({
  declarations: [LevelingSideGridComponent],
	exports: [LevelingSideGridComponent],
  imports: [
    CommonModule,
		DxDataGridModule,
		DxButtonModule,
  ]
})
export class LevelingSideGridModule { }
